import MuiButton from '@mui/material/Button';
import { ToggleButtonProps } from './interface';
import React from 'react';
import { palette } from '@src/theme';

export const ToggleButton = ({
  children,
  variant,
  size,
  startIcon,
  endIcon,
  disabled,
  selected,
  onChange,
  squared,
}: ToggleButtonProps) => {
  const sharedOutlinedStyle = {
    border: `1px solid ${palette.controls.outline}`,
    backgroundColor: selected ? palette.state.teal['backing-1'] : undefined,
    borderRadius: squared ? '4px' : undefined,
    color: palette.state.teal.secondary,
    '&:hover': {
      backgroundColor: selected ? palette.state.teal.backing : palette.surface['hover+focused'],
    },
    '&:focus': {
      backgroundColor: palette.surface.secondary,
      border: `2px solid ${palette.state.teal.secondary}`,
    },
    '&:active': {
      backgroundColor: selected ? palette.state.teal['backing-1'] : palette.surface.pressed,
    },
  };

  const SX_MAPPING: Record<'outlined' | 'text', Record<string, any>> = {
    outlined: {
      small: {
        padding: '3px 9px 3px 9px',
        ...sharedOutlinedStyle,
      },
      medium: {
        padding: '6px 16px 6px 16px',
        ...sharedOutlinedStyle,
      },
    },
    text: {
      small: {
        backgroundColor: undefined,
        color: palette.state.teal.secondary,
        '&:hover': {
          backgroundColor: palette.state.teal.backing,
        },
        '&:active': {
          backgroundColor: palette.state.teal['backing-1'],
        },
        '&:focus': {
          border: `2px solid ${palette.state.teal.secondary}`,
        },
      },
      medium: {
        backgroundColor: undefined,
        color: palette.state.teal.secondary,
        '&:hover': {
          backgroundColor: palette.state.teal.backing,
        },
        '&:active': {
          backgroundColor: palette.state.teal['backing-1'],
        },
        '&:focus': {
          borderColor: palette.state.teal.secondary,
          borderWidth: '2px',
        },
      },
    },
  };
  return (
    <MuiButton
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      sx={SX_MAPPING[variant][size]}
      disableElevation
      onClick={() => onChange(!selected)}
    >
      {children}
    </MuiButton>
  );
};
